import { gql } from '@apollo/client';
import { IName, IResidentBaseData } from '@dokucoach/common-types';
import {
  queryAllResidentData,
  queryResidentAddress,
  queryResidentMenuData,
  queryResidentNameAndId,
} from './query/residents';

export type Resident = Partial<{
  id: string;
  deletedAt?: Date;
  nursingHomeId: string;
  name: IName;
  residentBaseData: IResidentBaseData;
  bed?: { label: string; id: string };
  identifier?: string;
  alternativeIndicatorNumber?: string;
  nursingHome?: { name: string };
}>;

export const GET_RESIDENT_BY_ID = gql`
  query getResidentById($id: String!) {
    getResident(id: $id) {
      ${queryAllResidentData}
      bed {
        id
        label
      }
      nursingHome {
        name
      }
    }
  }
`;

export const GET_RESIDENT_NAME_AND_ID_BY_ID = gql`
  query getResidentById($id: String!) {
    getResident(id: $id) {
      ${queryResidentNameAndId}
    }
  }
`;

export const GET_RESIDENTS_FLAGS_BY_ID = gql`
  query getResidentFlagsById($id: String!) {
    getResident(id: $id) {
      isAbsent
    }
  }
`;

export const GET_RESIDENT_IS_DELETED_BY_ID = gql`
  query getResidentIsDeletedById($id: String!) {
    getResident(id: $id) {
      deletedAt
    }
  }
`;

export const GET_RESIDENTS = gql`
  query getResidents($isDeleted: Boolean, $isActive: Boolean, $isAbsent: Boolean, $isApplicant: Boolean){
    getResidents(isDeleted: $isDeleted, isActive: $isActive, isAbsent: $isAbsent, isApplicant: $isApplicant) {
      ${queryResidentMenuData}
    }
  }
`;

export const GET_RESIDENTS_NAME_AND_ID = gql`
  query getResidentsNameAndId {
    getResidents(isDeleted: false) {
      ${queryResidentNameAndId}
    }
  }
`;

export const GET_RESIDENTS_FOR_SEPA_POCKET = gql`
  query getResidentsForSepaPocket {
    getResidentsForSepaPocket {
      ${queryResidentNameAndId}
    }
  }
`;

export const GET_RESIDENTS_NAME_AND_ID_ALL = gql`
  query getResidentsNameAndId {
    getResidents(isDeleted: null, isActive: null, isAbsent: null) {
      ${queryResidentNameAndId}
    }
  }
`;

export const GET_ALL_RESIDENTS_BY_HOUSE_DIVISION = gql`
  query getAllRelatedResidentsByHouseDivision($houseDivisionId: String!) {
    getAllRelatedResidentsByHouseDivision(houseDivisionId: $houseDivisionId) {
      ${queryResidentMenuData}
    }
  }`;

export const GET_ALL_BEDS = gql`
  query beds {
    houseDivisions(type: BED) {
      id
      type
      name
      label
      parentId
      residentId
    }
  }
`;

export const GET_ALL_WITHOUT_INVOICE = gql`
  query getResidentsWithoutInvoice($year: Float!, $month: Float!) {
    getResidentsWithoutInvoice(year: $year, month: $month) {
      ${queryResidentNameAndId}
    }
  }
`;

export const GET_RESIDENT_ADDRESS_BY_ID = gql`
  query getResident($id: String!) {
    getResident(id: $id) {
      ${queryResidentAddress}
    }
  }
`;
